"use client";
import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { getQuestionCardLanguages } from "../services/questionCardService";
import { toastMessage } from "./toast";
import theme from "../../../apps/dashboard/src/helpers/theme";
import { CountriesLanguageList } from "../pages/countries/countries-language-list";
import { groupBy } from "lodash";
import { type Translationtype } from "utils";

interface LanguageFlagSlectorPops {
  selectedLanguage: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
  t: Translationtype;
}

export function LanguageFlagSlector({
  selectedLanguage,
  setLanguage,
  t,
}: LanguageFlagSlectorPops) {
  /* eslint-disable @next/next/no-img-element */
  const [languageList, setLanguageList] = useState<string[]>([]);
  const [defaultValue] = useState<string>(selectedLanguage);

  useEffect(() => {
    const newlanguageList: string[] = [];
    getQuestionCardLanguages()
      .then((countries) => {
        const shippingEnabledCountries = countries.filter(
          (country) => country.shippingEnabled
        );
        const languageTypeList = groupBy(
          shippingEnabledCountries,
          "languageCode"
        );
        Object.keys(languageTypeList).forEach((languageType) => {
          newlanguageList.push(languageType);
        });

        setLanguageList(newlanguageList);
      })
      .catch(() => toastMessage.error(t("Toast.errorgetCountries" as any)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getOptionLabel = (option: string) => {
    return CountriesLanguageList.find((cl) => cl.CultureInfo === option)
      ?.Language;
  };

  return (
    <Autocomplete
      id="qcard-lang-selector"
      disableClearable
      options={languageList}
      autoHighlight
      getOptionLabel={(option) => getOptionLabel(option) ?? ""}
      className="bg-white"
      defaultValue={defaultValue}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            border: `2px solid ${theme.colors.gray[700]}`,
          },
      }}
      onChange={(event: any, newValue: string) => setLanguage(newValue)}
      renderOption={(props, option) => (
        <Box
          key={option}
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            srcSet={`https://flagcdn.com/w40/${option
              .slice(-2)
              .toLowerCase()}.png 2x`}
            src={`https://flagcdn.com/w20/${option
              .slice(-2)
              .toLowerCase()}.png`}
            alt=""
          />
          {getOptionLabel(option)}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("LanguageFlagSelector.label")}
          InputLabelProps={{
            style: { color: theme.colors.gray[700] },
          }}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )}
    />
  );
}
